import { useResponsiveValue, useUID } from '@superdispatch/ui';
import { DriverField } from '../../drivers/core/DriverField';
import { Ref } from 'react';
import { DispatcherField } from '../../../shared/modules/dispatcher/DispatcherField';
import { TerminalField } from '../../terminals/TerminalField';
import { formatLoadsPageField } from '../data/LoadsPageParams';
import {
  LoadsPageFilterFieldActions,
  LoadsPageFilterFieldLabel,
} from './LoadsPageFilterField';

interface LoadsPageFilterResourceFieldProps {
  name: 'drivers' | 'dispatchers' | 'terminals';
  inputRef: Ref<HTMLInputElement>;
  value: null | undefined | string;
  onChange: (value: undefined | string) => void;
}

export function LoadsPageFilterResourceField({
  name,
  value,
  onChange,
  inputRef,
}: LoadsPageFilterResourceFieldProps) {
  const uid = useUID();

  const fieldComponents = {
    drivers: DriverField,
    dispatchers: DispatcherField,
    terminals: TerminalField,
  } as const;

  const FilterAutocomplete = fieldComponents[name];

  const isMobile = useResponsiveValue(true, false);

  return (
    <FilterAutocomplete
      id={uid}
      value={value}
      forcePopupIcon={false}
      disableClearable={true}
      onChange={onChange}
      TextFieldProps={{
        inputRef,
        placeholder: 'Search and select',
        label: isMobile && formatLoadsPageField(name),
        InputProps: {
          startAdornment: !isMobile && (
            <LoadsPageFilterFieldLabel name={name} htmlFor={uid} />
          ),
          endAdornment: (
            <LoadsPageFilterFieldActions
              hasValue={!!value}
              onClear={() => {
                onChange(undefined);
              }}
            />
          ),
        },
      }}
    />
  );
}
